var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5 mb-5"},[_c('i',{staticClass:"bx bx-hourglass bx-spin font-size-16 align-middle mr-2"}),_vm._v(" "+_vm._s(_vm.$t("common.loading"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }